import React from 'react';
import './App.css';
import CustomNavbar from './components/CustomNavBar'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import watch1 from './Images/GarminWatchApp.png';
import watch1_thumb from './Images/GarminWatchApp_thumb.png';
import ImageGallery from 'react-image-gallery';
import logo from './Images/TrueNorth_contacts.png';
import CustomBtn from './components/CustomButton'
import  { FirebaseContext } from "./components/Firebase";
import { Route, Link, BrowserRouter as Router } from 'react-router-dom';
//import "react-image-gallery/styles/css/image-gallery.css";
import './ImageGallery.css';
import { textAlign } from '@material-ui/system';

//function App() {

class TrueNorthContacts extends React.Component {


render() {

  const boxStyle = { 
    width: 'fit-content', 
    background:'rgba(248, 248, 248, 0.6)', 
    borderRadius:'5px', 
    padding:'15px', 
    margin: '5px',
    minHeight: '500px',
    minWidth: '400px',
    boxShadow:'0 8px 12px 0 rgba(0, 0, 0, 0.24), 0 6px 20px 0 rgba(0, 0, 0, 0.18)'
  };

  const images = [
    {
      original: watch1,
      thumbnail: watch1_thumb,
    },
  ]

  return (
    <div style={{height:'100%'}}>
    <div style={{minHeight:'92vh'}}>
    <CustomNavbar logo={true}></CustomNavbar>

    <Grid container direction="column" justify={'center'} alignItems={'center'} style={{marginLeft:'-10px' ,paddingTop:'30px'}}>
      <Typography variant="h5" style={{ marginBottom:'30px', color:'black', maxWidth:"80%", padding:'0px 35px 3px 35px', borderBottom: '1px solid #8d8c8c'}}>
         Contact us
      </Typography>  

      <Typography variant="body2" style={{ color:'black', marginBottom:'5px'}}>
         Email
      </Typography>  
      <Typography variant="body2" color="primary" style={{ marginBottom:'20px'}}>
         truenorthsailingsoftware@gmail.com
      </Typography>  

      <Typography variant="body2" style={{ color:'black', marginBottom:'5px'}}>
         Phone
      </Typography>  
      <Typography variant="body2" color="primary"  style={{ marginBottom:'20px'}}>
         +27 84 600 6091
      </Typography>  

      <Typography variant="body2" style={{ color:'black', marginBottom:'5px'}}>
         Location
      </Typography>  
      <Typography variant="body2" color="primary"  style={{ marginBottom:'20px'}}>
         Cape Town, South Africa
      </Typography>  



    </Grid>
    </div>

    <div style={{minHeight:'8vh', boxShadow:'0 0px 12px 0 rgba(0, 0, 0, 0.4), 0 0px 20px 0 rgba(0, 0, 0, 0.4)', backgroundColor:'#313131'}}>
    <Grid container direction="row" justify={'center'} alignItems={'center'} style={{height:'8vh'}}>
    <Typography variant="body2" style={{color:'white', textAlign: 'center'}}>
                  Contact us at truenorthsailingsoftware@gmail.com | +27-84-600-6091
    </Typography>
    </Grid>
    </div> 


    </div>
    );
  }
}

export default TrueNorthContacts;
